module.exports = __webpack_public_path__ + "static/media/Header1.b70791e2.jpg";